import ArrowLeft from "@/components/Svg/ArrowLeft";
import { DataBannerTypes } from "@/types/BannerType";
import Image from "next/image";
import Link from "next/link";
import React from "react";
function SixBannerWith2Section({ dataTemplate }: DataBannerTypes) {
  const threeBannerLink = `pt-[60%]  rounded-[0.75rem]  sm:rounded-[0.75rem]  lg:rounded-3xl relative  overflow-hidden`;
  const threeBannerImageClass = `w-full h-full object-cover rounded-[0.75rem] sm:rounded-[0.75rem] lg:rounded-3xl absolute inset-0 hover:filter z-20 hover:blur-[2px] transition-all duration-300`;
  const threeBannerParentSpan = `absolute bottom-0 flex  items-end justify-center z-30  w-full rounded-b-2xl lg:rounded-b-3xl  h-max text-white md:text-lg sm:text-lg text-xs lg:text-xl xl:text-2xl`;
  const threeBannerSpan = `sm:p-6 p-2  text-right  flex  items-center gap-2 lg:gap-6    w-full bg-gradient-to-t z-30 from-[#1A1818] to-transparent`;
  const threeBannerArrow = `stroke-[#FFC20A]`;
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 lg:gap-10 my-5 lg:my-5 lg:px-16 px-6">
      {dataTemplate?.map((threeBannerData, index) => (
        <Link
          key={index + 1}
          href={threeBannerData?.link ?? "/"}
          className={threeBannerLink}
          style={{ order: Number(threeBannerData?.positionInTemplate) }}
        >
          <Image
            priority
            fetchPriority="high"
            sizes="100vw"
            unoptimized
            src={threeBannerData?.patchImage ?? "/images/default.png"}
            quality={100}
            width={5000}
            height={3000}
            className={threeBannerImageClass}
            alt={`banner-${index + 1}`}
          />
          <span className={threeBannerParentSpan}>
            <span className={threeBannerSpan}>
              {threeBannerData?.title}
              <ArrowLeft className={threeBannerArrow} />
            </span>
          </span>
        </Link>
      ))}
    </div>
  );
}

export default SixBannerWith2Section;
